var _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "black"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 15,
    fontFamily: "Arial, sans-serif",
    fontWeight: 500,
    fontSize: 16,
    fill: "white",
    textAnchor: "middle"
  }, "u/")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogo);
export default __webpack_public_path__ + "static/media/userLogo.0af7954a5dffb347620b8a91d57210dc.svg";
export { ForwardRef as ReactComponent };